import InfoPopover from "../infoPopover/infoPopover"
import { useLanguage } from "../../contexts/LanguageContext"

/**
 * Multi-line text input with integrated reset button.
 * @param {Object} props
 * @param {Object} props.element - Configuration element
 * @param {Object} props.parameters - Current parameters state
 * @param {Function} props.setParameters - Function to update parameters
 * @returns {JSX.Element}
 */
function TextArea({ element, parameters, setParameters }) {
  const { t } = useLanguage()
  return (
    <div className="row textArea">
      <div className="col-5">
        <InfoPopover element={element} />
        <span>{element?.label ? t(element.label) : element?.label}</span>
      </div>
      <div className="col">
        <textarea id={`input-${element.id}`} className="form-control" value={parameters[element.id] || ""} onChange={event => setParameters({ ...parameters, [element.id]: event.target.value })} />
        <div className="resetBloc" onClick={() => setParameters({ ...parameters, [element.id]: element.default })} />
      </div>
    </div>
  )
}

export default TextArea
